// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalBackground_container__V_nCS"};